import React, { type FC } from "react";

const GooglePayIcon: FC<{ className?: string }> = ({ className }) => (
  <svg
    viewBox="0 0 36 17"
    fill="currentColor"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_476_9)">
      <path
        d="M17.0099 8.79011V12.9397H15.6599V2.67725H19.1699C20.0249 2.67725 20.8349 2.98958 21.4649 3.56963C22.0949 4.10507 22.4099 4.90822 22.4099 5.75599C22.4099 6.60376 22.0949 7.36229 21.4649 7.94234C20.8349 8.52239 20.0699 8.83473 19.1699 8.83473L17.0099 8.79011ZM17.0099 3.92659V7.49614H19.2599C19.7549 7.49614 20.2499 7.31767 20.5649 6.96071C21.2849 6.29142 21.2849 5.17593 20.6099 4.50664L20.5649 4.46202C20.2049 4.10507 19.7549 3.88197 19.2599 3.92659H17.0099Z"
        fill="#5F6368"
      />
      <path
        d="M25.5149 5.71118C26.5049 5.71118 27.2699 5.9789 27.8549 6.51433C28.4399 7.04976 28.7099 7.76367 28.7099 8.65606V12.9395H27.4499V11.9579H27.4049C26.8649 12.7611 26.0999 13.1626 25.1999 13.1626C24.4349 13.1626 23.7599 12.9395 23.2199 12.4933C22.7249 12.0471 22.4099 11.4225 22.4099 10.7532C22.4099 10.0393 22.6799 9.45921 23.2199 9.01302C23.7599 8.56682 24.5249 8.38835 25.4249 8.38835C26.2349 8.38835 26.8649 8.5222 27.3599 8.83454V8.52221C27.3599 8.07601 27.1799 7.62982 26.8199 7.3621C26.4599 7.04976 26.0099 6.87129 25.5149 6.87129C24.7499 6.87129 24.1649 7.18362 23.7599 7.80829L22.5899 7.09438C23.3099 6.15738 24.2549 5.71118 25.5149 5.71118ZM23.8049 10.7978C23.8049 11.1548 23.9849 11.4671 24.2549 11.6456C24.5699 11.8687 24.9299 12.0025 25.2899 12.0025C25.8299 12.0025 26.3699 11.7794 26.7749 11.3778C27.2249 10.9763 27.4499 10.4855 27.4499 9.95003C27.0449 9.63769 26.4599 9.45921 25.6949 9.45921C25.1549 9.45921 24.7049 9.59307 24.3449 9.86079C23.9849 10.0839 23.8049 10.3962 23.8049 10.7978Z"
        fill="#5F6368"
      />
      <path
        d="M36.0001 5.93433L31.5451 16.0629H30.1951L31.8601 12.538L28.9351 5.97895H30.3751L32.4901 11.0209H32.5351L34.6051 5.97895H36.0001V5.93433Z"
        fill="#5F6368"
      />
      <path
        d="M11.6549 7.8976C11.6549 7.49602 11.6099 7.09445 11.5649 6.69287H5.93994V8.96846H9.13494C8.99994 9.68237 8.59494 10.3517 7.96494 10.7532V12.2257H9.89994C11.0249 11.1994 11.6549 9.68237 11.6549 7.8976Z"
        fill="#4285F4"
      />
      <path
        d="M5.93988 13.6534C7.55988 13.6534 8.90988 13.118 9.89988 12.2256L7.96488 10.7532C7.42488 11.1101 6.74988 11.3332 5.93988 11.3332C4.40988 11.3332 3.05988 10.307 2.60988 8.87915H0.629883V10.3962C1.66488 12.4041 3.68988 13.6534 5.93988 13.6534Z"
        fill="#34A853"
      />
      <path
        d="M2.61002 8.87932C2.34002 8.16541 2.34002 7.36226 2.61002 6.60373V5.08667H0.63002C-0.22498 6.73759 -0.22498 8.70084 0.63002 10.3964L2.61002 8.87932Z"
        fill="#FBBC04"
      />
      <path
        d="M5.94005 4.19419C6.79505 4.19419 7.60505 4.50653 8.23505 5.08658L9.94505 3.39104C8.86505 2.40942 7.42505 1.82936 5.98505 1.87398C3.73505 1.87398 1.66505 3.12333 0.675049 5.1312L2.65505 6.64826C3.06005 5.22044 4.41005 4.19419 5.94005 4.19419Z"
        fill="#EA4335"
      />
    </g>
    <defs>
      <clipPath id="clip0_476_9">
        <rect width="36" height="17" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default GooglePayIcon;
